import { render, staticRenderFns } from "./SignatureDialog.vue?vue&type=template&id=2de4c373&"
import script from "./SignatureDialog.vue?vue&type=script&lang=js&"
export * from "./SignatureDialog.vue?vue&type=script&lang=js&"
import style0 from "./SignatureDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VSelect,VTab,VTabItem,VTabs,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3289102252/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2de4c373')) {
      api.createRecord('2de4c373', component.options)
    } else {
      api.reload('2de4c373', component.options)
    }
    module.hot.accept("./SignatureDialog.vue?vue&type=template&id=2de4c373&", function () {
      api.rerender('2de4c373', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/proposal/proposal-renderer/SignatureDialog.vue"
export default component.exports